import { pulseAxiosInstance } from "@pulse/api/axiosInstance";
import LanguageSelector from "@pulse/features/SurveyResponse/LanguageSelector/LanguageSelector";
import SurveyResponse from "@pulse/features/SurveyResponse/SurveyResponse";
import { useParams } from "@tanstack/react-router";
import { useLayoutEffect } from "react";

export default function SurveyResponsePage() {
    const participantId = useParams({ from: "/pulse/surveys/$participantId" }).participantId;
    useLayoutEffect(() => {
        pulseAxiosInstance.defaults.headers["x-participant-uuid"] = participantId;
        return () => {
            delete pulseAxiosInstance.defaults.headers["x-participant-uuid"];
        };
    }, [participantId]);
    return (
        <div>
            <div className="h-12 flex items-center px-4 justify-end">
                <LanguageSelector />
            </div>
            <div className="flex items-center justify-center">
                <SurveyResponse />
            </div>
        </div>
    );
}
